import { Box, useTheme } from "@mui/material";

function ThreeDotsLoader({ size = 20 }) {
  const theme = useTheme();
  return (
    <Box
      sx={{
        width: size,
        height: size,
        // background: theme.palette.background.light,
        // borderRadius: "50%",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        // filter: "grayscale(1)",
        // opacity: 0.7,
      }}>
      <img
        src={"/images/loaders/3-dots-loader.gif"}
        alt="loader"
        style={{
          width: size,
          height: size,
          display: "block",
          opacity: 0.7, // add some opacity to the loader image
        }}
      />
    </Box>
  );
}

export default ThreeDotsLoader;
